import { createFileRoute, useLocation, useSearch } from '@tanstack/react-router';
import { useTheme, useMediaQuery } from '@mui/material';
import { useCallback } from 'react';
import {
  BargeDashboard,
  ContainerSelectionArgs,
  ContainerTypeLegacy,
  navigateTo,
  navigateToError,
  useGetViewer,
} from '@amber-ui/core';

function BargeDashboardRoute() {
  const { pathname } = useLocation();
  const theme = useTheme();
  // down('md') = < 960px, matches AuthLayout's mobile_width definition (width === 'sm' || 'xs').
  // Previously used down('sm') || only('xs') which was < 600px — inconsistent with AuthLayout.
  const matchesMobile = useMediaQuery(theme.breakpoints.down('md'));
  const mobile_width = matchesMobile;

  // Read barge ID from URL search params (source of truth)
  const { barge } = useSearch({ strict: false }) as { barge?: string };
  const { viewer } = useGetViewer();

  const barge_id = barge || null;

  const goCreateBarge = useCallback(() => {
    navigateTo('/barge/create');
  }, []);
  const goCreatePile = useCallback(() => {
    navigateTo('/pile/create');
  }, []);
  const goCreateGrainBin = useCallback(() => {
    navigateTo('/grain_bin/create');
  }, []);
  const goBargeCoverForm = useCallback(({ pellet_id }: { pellet_id: string }) => {
    navigateTo('/barge/cover', { pellet_id });
  }, []);
  const onSelectContainer = useCallback((selected: ContainerSelectionArgs) => {
    if (selected.container_type === ContainerTypeLegacy.bin) {
      navigateTo('/grain_bin/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.barge) {
      navigateTo('/barge/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.pile) {
      navigateTo('/pile/dashboard', selected);
    }
  }, []);

  if (!viewer) return <div>Loading...</div>;

  return (
    <BargeDashboard
      barge_id={barge_id}
      mobile_width={mobile_width}
      pathname={pathname}
      viewer={viewer}
      onError={() => {
        navigateToError();
      }}
      goBargeCoverForm={goBargeCoverForm}
      goCreateBarge={goCreateBarge}
      goCreatePile={goCreatePile}
      goCreateGrainBin={goCreateGrainBin}
      onSelectContainer={onSelectContainer}
    />
  );
}

export const Route = createFileRoute('/_auth/_barge/barge/dashboard')({
  component: BargeDashboardRoute,
});
